import { Typography } from '@mui/material';
import { node, string, object } from 'prop-types';
import React, { memo } from 'react';

const classes = {
  root: {
    marginTop: '1.333em',
    marginBottom: '0.467em',
    fontSize: 15,
    fontWeight: 600,
  },
};

const Label = ({ children, className = null, sx = {} }) => {
  return (
    <Typography className={className} variant="body1" sx={{ ...classes.root, ...sx }}>
      {children}
    </Typography>
  );
};

Label.propTypes = {
  className: string,
  children: node.isRequired,
  sx: object,
};

export default memo(Label);
